<template src='./index.html'></template>
<script>
import { getdata } from './data';
import { page } from '../../../api/operationLog';
export default {
    data() {
        return {
            searchdata: getdata().searchdata, //搜索输入内容
            searchlist: getdata().searchlist, //搜索数据
            pagination: getdata().pagination, //分页数据
            headData: getdata().headData, //表单表头数据
            tableData: [{}], //表单内容
            overlength: 0, //搜索条件展开高度
            tablekey: 0
        };
    },
    created() {
        this.page(); //分页数据查询
    },
    methods: {
        //查询数据展开 修复高度造成的bug
        geOoverLength(e) {
            this.overlength = e;
        },
        page() {
            //获取分页数据
            let params = {
                businessName: this.searchdata.businessName,
                operName: this.searchdata.operName,
                current: this.pagination.pageNum,
                size: this.pagination.pageSize
            };
            if (this.searchdata.createDate!=null) {
                params.operationStartTime = this.searchdata.createDate[0];
                params.operationEndTime = this.searchdata.createDate[1];
            }
            page(params).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = res.data.data.records;
                    this.pagination.total = res.data.data.total;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        //查询按钮
        submitSearch() {
            this.pagination.pageNum = 1;
	        this.pagination.paginationkey++;
            this.page();
        },
        //切换条数
        sizechange(e) {
            this.pagination.pageSize = e;
            this.page();
        },
        //切换页码
        currentChange(e) {
            this.pagination.pageNum = e;
            this.page();
        }
    },
    components() {}
};
</script>
